import type { FaireProductEntity } from "../../entity_types/product";

export const p_8swfr6aw22: FaireProductEntity = {
  token: "p_8swfr6aw22",
  type: "product",
  name: "Moroccan Visage Vase",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/fce0ac271d039dde6165171b5fa08a7f8eca1a14285b46063c4f63abce0fa7be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4b6dbb575391469848e0be768c449d93f14df50f51d92127b0c10a20f248105a.jpeg",
    "https://cdn.faire.com/fastly/6e55d190cb85ea6f6bb39f2b0a93ed989443d536699e5a8df3e724a3a44d951b.jpeg",
    "https://cdn.faire.com/fastly/595ab7ae8b8a541aeee0aa68a1e282fd6a9b30ed3ad3385a9e3a4bb9a11f5a45.jpeg",
    "https://cdn.faire.com/fastly/66fd2408d55787f538698bc33e06c721b5c22ff1cb4ecbae813cf620e82f02fd.jpeg",
    "https://cdn.faire.com/fastly/4a713d3c4493ad9700f628ed057c58886440da18f8b23edd8a289442a2acba62.jpeg",
    "https://cdn.faire.com/fastly/722686a0295bc688f7dbeb31fffb8d46b9d8c169a0fb6753456eb2f0cb7164fc.jpeg",
    "https://cdn.faire.com/fastly/35d5349d70ad76af3d7c441fd6132192f851d6bf353851edb4a1ec4b6ac67a9c.jpeg",
    "https://cdn.faire.com/fastly/c82f458bf21650bec632e0bbff0eb5872bc48c843380668e031f14dd5c42a383.jpeg",
    "https://cdn.faire.com/fastly/80911b969869f55f29203e0193b8c5a6a91a873aabb9f2f9dfcdfec5bb347d38.jpeg",
  ],
  priceDollars: 45,
  description:
    "This unique ceramic vase from Morocco combines artisanal craftsmanship with modern artistry. Handmade and hand-painted by skilled Moroccan artisans, each vase showcases a unique abstract face design that adds a touch of contemporary elegance to any decor. With its smooth ceramic finish and distinctive lines, this piece is perfect to add unique decor to your space, while also holding dried/faux flowers or simply as a standalone art piece. Bring a piece of Morocco’s vibrant culture and artistic spirit into your home with this beautifully expressive vase.\n\nThis vase may not hold water so is recommended as a decorative vase, or you can place a glass holder inside to hold fresh flowers.",
  tags: [],
  msrpDollars: 90,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:19.135Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
